import {
  ProductOffering,
  getFeaturedItemAndTextForTracking,
} from '@travelwin/core';
import { SelectViewItemEventData } from './tracking-events';

export type BuildSelectItemOptions = {
  plan: ProductOffering;
  index?: number;
  countryName?: string;
  itemListName?: string;
  baseItemId?: string;
};

export const buildSelectItemEventData = ({
  plan,
  index,
  countryName,
  itemListName = 'n/a',
  baseItemId,
}: BuildSelectItemOptions): SelectViewItemEventData => {
  const price = plan.product_offering_pricing[0].total_price_gross;
  const currency =
    plan.product_offering_pricing[0].currency.alias.toUpperCase();

  return {
    currency,
    price,
    items: [
      {
        id: plan.id,
        name: plan.name,
        brand: plan.mvno.alias,
        quantity: 1,
        retailerId: plan.retailer.id,
        countryName,
        itemListName,
        price,
        currency,
        index,
        baseItemId,
        ...getFeaturedItemAndTextForTracking(plan),
      },
    ],
  };
};
